import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { ButtonComponent } from '../../shared/ui/button/button.component';
import { NEWSLETTER_COPY } from '../../shared/ui/newsletter-form/newsletter.copy';

/**
 * `/newsletter/confirmada` (B9, W5): destino de `BREVO_DOI_REDIRECT_URL` tras
 * confirmar el doble opt-in en Brevo. Estática y sin llamadas a la API; el SEO
 * (`noindex,follow`) lo aplica el `seoResolver` desde `data.seo` de la ruta, y
 * queda fuera del sitemap (lista blanca de `tools/build-sitemap.mjs`).
 */
@Component({
  selector: 'app-newsletter-confirmed-page',
  imports: [ButtonComponent, RouterLink, NgOptimizedImage],
  templateUrl: './newsletter-confirmed-page.component.html',
  styleUrl: './newsletter-confirmed-page.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewsletterConfirmedPageComponent {
  protected readonly copy = NEWSLETTER_COPY;
}
